export function afterLast(input: string, target: string): string {
  const lastSlashIndex = input.lastIndexOf(target)
  return lastSlashIndex !== -1 ? input.substring(lastSlashIndex + 1) : input
}

export const afterLastSlash = (input: string) => afterLast(input, '/')
